export const SUPPORT_DESK_CHANNELS = ['PHONE', 'WHATSAPP', 'EMAIL', 'CHAT', 'IN_APP'];
export const SUPPORT_SUBJECT_KINDS = ['RIDER', 'DRIVER', 'RIDE', 'DESK_ORDER'];
/** D637: what a ticket can be about - the four an agent looks up, plus the food order, delivery and payment a customer names from the app. */
export const SUPPORT_TICKET_SUBJECT_KINDS = [...SUPPORT_SUBJECT_KINDS, 'FOOD_ORDER', 'DELIVERY', 'PAYMENT'];
export const SUPPORT_TICKET_CATEGORIES = ['TRIP', 'PAYMENT', 'DRIVER', 'RIDER', 'SAFETY', 'LOST_ITEM', 'ACCOUNT', 'DOCUMENT', 'MERCHANT'];
export const TICKET_RESOLUTIONS = ['ANSWERED', 'ACTION_TAKEN', 'DUPLICATE', 'NO_RESPONSE', 'NOT_REPRODUCIBLE', 'REFERRED'];
export const COMPENSATION_REASONS = ['SERVICE_FAILURE', 'OVERCHARGE', 'DRIVER_CONDUCT', 'SAFETY_FOLLOW_UP', 'GOODWILL'];
export const CONTACT_REVEAL_PURPOSES = ['trip_support', 'payment_dispute', 'safety_incident', 'account_help'];
/** D448 (S-02): the statuses the queue lists by default (the open ones). */
export const OPEN_QUEUE_STATUSES = ['OPEN', 'ASSIGNED', 'PENDING', 'REOPENED'];
export const ALL_TICKET_STATUSES = ['OPEN', 'ASSIGNED', 'PENDING', 'RESOLVED', 'CLOSED', 'REOPENED'];
const enc = encodeURIComponent;
export class SupportDeskApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * The market queue; `market` (cc:slug) from the operator's own grants. D448 (S-02): the OPEN tickets by default, most
     * urgent then most due first; `status` narrows it (one status, a comma list, or `ALL`); `limit` + `offset` page it.
     */
    queue(query) {
        const qs = new URLSearchParams({
            market: query.market,
            ...(query.status !== undefined ? { status: query.status } : {}),
            ...(query.limit !== undefined ? { limit: String(query.limit) } : {}),
            ...(query.offset !== undefined && query.offset > 0 ? { offset: String(query.offset) } : {}),
            ...(query.protocol !== undefined && query.protocol.trim() !== '' ? { protocol: query.protocol.trim() } : {}),
        });
        return this.client.request({ method: 'GET', path: `/v1/support/tickets?${qs.toString()}`, auth: true });
    }
    /** D448 (S-01): answer the requester in writing (open, assigned to the caller, a self-filed ticket). */
    reply(ticketId, body) {
        return this.client.request({ method: 'POST', path: `/v1/support/tickets/${enc(ticketId)}/replies`, body: { body }, auth: true });
    }
    /**
     * Who a caller is about, in one market. D384 review (W5S-02): a POST — the handle (a phone) travels in the body, never in
     * a URL the request log would write out. Every lookup is recorded and budgeted (`SUPPORT_SUBJECT_LOOKUP_RATE_LIMITED`).
     */
    lookupSubject(query) {
        return this.client.request({ method: 'POST', path: '/v1/support/subjects/lookup', body: { market: query.market, kind: query.kind, q: query.q }, auth: true });
    }
    openForCaller(input) {
        return this.client.request({ method: 'POST', path: '/v1/support/tickets/for-caller', body: input, auth: true });
    }
    ticket(ticketId) {
        return this.client.request({ method: 'GET', path: `/v1/support/tickets/${enc(ticketId)}`, auth: true });
    }
    assignToSelf(ticketId) {
        return this.client.request({ method: 'POST', path: `/v1/support/tickets/${enc(ticketId)}/assign`, body: {}, auth: true });
    }
    addNote(ticketId, body) {
        return this.client.request({ method: 'POST', path: `/v1/support/tickets/${enc(ticketId)}/notes`, body: { body }, auth: true });
    }
    transition(ticketId, input) {
        return this.client.request({ method: 'POST', path: `/v1/support/tickets/${enc(ticketId)}/transition`, body: input, auth: true });
    }
    linkRide(ticketId, rideId) {
        return this.client.request({ method: 'POST', path: `/v1/support/tickets/${enc(ticketId)}/ride`, body: { rideId }, auth: true });
    }
    requestCompensation(ticketId, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/support/tickets/${enc(ticketId)}/compensation-request`, body: { reasonCode }, auth: true });
    }
    revealContact(ticketId, input) {
        return this.client.request({ method: 'POST', path: `/v1/support/tickets/${enc(ticketId)}/contact-reveal`, body: input, auth: true });
    }
    /** `currency` (D398): the market's own, for a Finance compensation proposal; null when nothing governs one. */
    compensationRequests(market, limit) {
        const qs = new URLSearchParams({ market, ...(limit !== undefined ? { limit: String(limit) } : {}) });
        return this.client.request({ method: 'GET', path: `/v1/support/compensation-requests?${qs.toString()}`, auth: true });
    }
}
//# sourceMappingURL=support-desk.js.map